import React from 'react';
import { Link } from 'react-router-dom';

const Media = () => {
  // Section titles ke liye common style
  const sectionTitleStyle = {
      color: '#003366',
      borderBottom: '2px solid #003366',
      paddingBottom: '10px',
      marginBottom: '20px',
      fontSize: '18px',
      fontFamily: 'serif',
      textTransform: 'uppercase'
  };

  // Dummy News Data (Baad mein backend se ayega)
  // Note: Images wahi use kar rahe hain jo aapke paas public/images mein hain
  const newsArticles = [
    {
      id: 1,
      title: "Prime Minister Dorin Recean chaired the meeting of the Commission for Emergency Situations",
      date: "17-01-2026 14:30",
      image: "/images/20251229-1ES_5784.jpg",
      summary: "Prime Minister Dorin Recean convened the Commission for Emergency Situations to discuss current challenges and ensure national security measures are in place."
    },
    {
      id: 2,
      title: "Government approves new measures to support agricultural producers affected by drought",
      date: "16-01-2026 11:00",
      image: "/images/20251229-1ES_4843.jpg",
      summary: "The Executive approved a series of decisions aimed at supporting farmers, including subsidies and diesel fuel aid for the upcoming season."
    },
    {
      id: 3,
      title: "Meeting of the Governmental Commission for European Integration took place today",
      date: "15-01-2026 09:15",
      image: "/images/20251229-_ES29651.jpg",
      summary: "Discussions focused on the progress of implementing the National Plan for EU Accession and preparing for the next intergovernmental conference."
    },
    {
        id: 4,
        title: "Deputy Prime Minister Oleg Serebrian met with the Special Representative of the OSCE",
        date: "14-01-2026 16:45",
        image: "/images/20251229-1ES_4993.jpg",
        summary: "Topics related to the Transnistrian settlement process and regional security were discussed during the meeting held at the Government building."
      }
  ];

  return (
    <div className="container mt-5 mb-5">
      <div className="row">

        {/* === LEFT COLUMN: Media Sidebar Menu === */}
        <div className="col-lg-3 mb-4">
            <h4 style={sectionTitleStyle}>MEDIA</h4>
            <div className="list-group list-group-flush font-serif">
                {/* Active Item */}
                <Link to="/media" className="list-group-item list-group-item-action text-primary fw-bold border-0 ps-0 bg-transparent">
                    <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> Press Releases
                </Link>
                {/* Other Items (Dummy links) */}
                {['Video Gallery', 'Photo Gallery', 'Speeches and Messages', 'Interviews and Statements', 'Accreditation for journalists'].map((item, index) => (
                    <a href="#" key={index} className="list-group-item list-group-item-action text-secondary border-0 ps-0 bg-transparent">
                        <i className="fa fa-chevron-right me-2" style={{fontSize:'10px'}}></i> {item}
                    </a>
                ))}
            </div>
        </div>

        {/* === CENTER COLUMN: News Articles List === */}
        <div className="col-lg-6 mb-4">
            <h4 style={sectionTitleStyle}>PRESS RELEASES</h4>

            <div className="d-flex flex-column gap-4">
                {newsArticles.map(item => (
                    // Horizontal Card Structure for News
                    <div className="card border-0 shadow-sm overflow-hidden" key={item.id}>
                        <div className="row g-0">
                            <div className="col-md-4">
                                {/* Image container to ensure consistent height */}
                                <div style={{height: '100%', minHeight: '180px'}}>
                                     <img src={item.image} className="img-fluid h-100 w-100" alt={item.title} style={{objectFit: 'cover'}}/>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className="card-body py-3">
                                    <small className="text-muted d-block mb-2">
                                        <i className="fa fa-calendar me-1"></i> {item.date}
                                    </small>
                                    
                                    {/* Title Link */}
                                    <h5 className="card-title mb-2" style={{fontFamily: 'serif', lineHeight: '1.3'}}>
                                        {/* Future: Link to single article page like /media/1 */}
                                        <a href="#" className="text-decoration-none" style={{color: '#003366'}}>
                                            {item.title}
                                        </a>
                                    </h5>
                                    
                                    <p className="card-text small text-muted mb-2">
                                        {item.summary}
                                    </p>
                                    <a href="#" className="btn btn-link p-0 text-primary small fw-bold text-decoration-none">Read more <i className="fa fa-angle-right"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {/* Pagination (Static View) */}
                <nav aria-label="Page navigation" className="mt-3">
                    <ul className="pagination justify-content-center pagination-sm">
                        <li className="page-item disabled"><a className="page-link" href="#">Previous</a></li>
                        <li className="page-item active bg-primary border-primary"><a className="page-link bg-primary border-primary text-white" href="#">1</a></li>
                        <li className="page-item"><a className="page-link text-primary" href="#">2</a></li>
                        <li className="page-item"><a className="page-link text-primary" href="#">3</a></li>
                        <li className="page-item"><a className="page-link text-primary" href="#">Next</a></li>
                    </ul>
                </nav>
            </div>
        </div>

        {/* === RIGHT COLUMN: Agenda & Widget (Same as other pages) === */}
        <div className="col-lg-3">
            <h4 style={sectionTitleStyle}>AGENDA</h4>

            {/* Calendar Widget */}
            <div className="bg-white border rounded shadow-sm p-0 mb-4">
                <div className="d-flex justify-content-between align-items-center text-white p-2" style={{backgroundColor: '#003366'}}>
                    <button className="btn btn-sm text-white"><i className="fa fa-chevron-left"></i></button>
                    <span className="fw-bold">January 2026</span>
                    <button className="btn btn-sm text-white"><i className="fa fa-chevron-right"></i></button>
                </div>
                <div className="p-2">
                    <table className="table table-sm text-center border-0 mb-0" style={{fontSize: '12px'}}>
                        <thead>
                            <tr className="text-primary fw-bold">
                                <th>M</th><th>T</th><th>W</th><th>T</th><th>F</th><th>S</th><th>S</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td></td><td></td><td></td><td className="text-danger fw-bold border border-danger">1</td><td>2</td><td>3</td><td>4</td></tr>
                            <tr><td>5</td><td>6</td><td>7</td><td>8</td><td>9</td><td>10</td><td>11</td></tr>
                            <tr><td>12</td><td>13</td><td>14</td><td>15</td><td>16</td><td>17</td><td>18</td></tr>
                            <tr><td>19</td><td>20</td><td>21</td><td>22</td><td>23</td><td>24</td><td>25</td></tr>
                            <tr><td>26</td><td>27</td><td>28</td><td>29</td><td>30</td><td>31</td><td></td></tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Blue Bubble Widget */}
            <div className="d-flex justify-content-end mt-5">
                <div className="position-relative text-end" style={{maxWidth:'200px'}}>
                    <div className="bg-primary text-white p-3 rounded shadow" style={{backgroundColor: '#336699 !important', fontSize:'12px'}}>
                         <div className="d-flex justify-content-between align-items-start mb-2">
                            <strong>EUROPA PENTRU TINE!</strong>
                            <i className="fa fa-times-circle opacity-50" style={{cursor:'pointer'}}></i>
                         </div>
                        Află despre beneficiile și oportunitățile oferite Republicii Moldova de Uniunea Europeană.
                    </div>
                    <div style={{
                        width: 0, height: 0,
                        borderLeft: '10px solid transparent',
                        borderRight: '10px solid transparent',
                        borderTop: '15px solid #0d6efd',
                        marginLeft: 'auto', marginRight: '20px'
                    }}></div>
                    <img src="/images/plan_eu.png" className="rounded-circle mt-2 shadow" width="60" alt="EU"/>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
};

export default Media;